export default __webpack_public_path__ + "locales/tr/InviteDialog.json?hash=7e735179f1adbaaab3297a2476da982b";